<template>
  <div class="chart-box DA-links-chart">
    <vue3-chart-js
      v-if="loading == false"
      v-bind="{ ...DRPieChart }"
      class="chart-circle"
    />
    <p class="article-text" v-if="showMessage">No Data to Display</p>
  </div>
</template>

<script>
import Vue3ChartJs from "@j-t-mcc/vue3-chartjs";

export default {
  props: ["DRStatusData"],
  components: {
    Vue3ChartJs,
  },
  watch: {
    DRStatusData: function () {
      if (this.DRStatusData.length < 1) {
        this.showMessage = true;
      } else {
        this.showMessage = false;
      }
      this.updateGraph();
    },
  },
  mounted() {
    let vm = this;
    vm.updateGraph();
  },

  data() {
    return {
      loading: true,
      showMessage: false,
      DRPieChart: {
        type: "doughnut",
        data: {
          labels: [],
          datasets: [
            {
              backgroundColor: [
                "#FF0E52",
                "#8E30FF",
                "#FF7723",
                "#373E92",
                "#0263FF",
                "#00b6cb"
              ],
              data: [],
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              position: "left",
              labels: {
                padding: 10,
                usePointStyle: true,
              },
            },
          },
        },
      },
    };
  },
  methods: {
    updateGraph() {
      this.loading = true;
      this.DRPieChart.data.datasets[0].data = [];
      this.DRPieChart.data.labels = [];
      if (this.DRStatusData.length > 0) {
        this.DRStatusData.forEach((d) => {
          this.DRPieChart.data.datasets[0].data.push(d.link_count);
          this.DRPieChart.data.labels.push(d.label);
        });
      }else{
        this.showMessage = true;
      }
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
  },
};
</script>
